import { AdminProvider } from "application/contexts/admin/adminContext";
import Catalog from "areas/_catalog/Catalog";
import { Admin } from "areas/admin/Admin";
import NominalCashless from "areas/cashless/nominalCashless/NominalCashless";
import { OfflineRecharge } from "areas/cashless/offlineRecharge/OfflineRecharge";
import OfflineRechargePage from "areas/cashless/offilineRechargeV2/OfflineRechargePage";
import PosPaid from "areas/cashless/posPaid/PosPaid";
import PrePaid from "areas/cashless/prePaid/Prepaid";
import { StoresListPage } from "areas/catalog/pages/storesListPageChurch/StoresListPage";
import Home from "areas/home/Home";
import WalletPage from "areas/wallet/WalletPage";
import RequestDocument from "components/requestDocument/RequestDocument";
import { IOrderProviderRef } from "modules/order/presentation/OrderProvider";
import React, { FC, memo } from "react";
import { Route, Switch } from "react-router-dom";

interface IRoutesPropes {
  orderProvider: React.RefObject<IOrderProviderRef>;
}

const Routes: FC<IRoutesPropes> = memo(({ orderProvider }) => {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/catalog">
        <Switch>
          <Route exact path={"/catalog"}>
            <StoresListPage />
          </Route>
          <Route path={"/catalog/store/:storeId"}>
            <Catalog />
          </Route>
        </Switch>
      </Route>
      <Route
        path="/posPaid"
        component={() => <PosPaid orderProvider={orderProvider} />}
      />
      <Route
        path="/prePaid"
        component={() => <PrePaid orderProvider={orderProvider} />}
      />
      <Route
        path="/nominalCashless"
        component={() => <NominalCashless orderProvider={orderProvider} />}
      />
      <Route
        path="/offlineRecharge"
        component={() => <OfflineRecharge orderProvider={orderProvider} />}
      />
      <Route
        path="/offlineRechargeV2"
        component={() => <OfflineRechargePage orderProvider={orderProvider} />}
      />
      <Route path="/validateDocument" component={RequestDocument} />
      <Route path="/admin">
        <AdminProvider>
          <Admin></Admin>
        </AdminProvider>
      </Route>
      <Route path="/wallet">
        <WalletPage orderProvider={orderProvider} />
      </Route>
    </Switch>
  );
});

export default Routes;
